module.exports = __webpack_public_path__ + "img/photo-0041.a46f285b.jpg";